var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.51 0 20 4.49 20 10C20 15.51 15.51 20 10 20C4.49 20 0 15.51 0 10C0 4.49 4.49 0 10 0ZM6.67646 5.63289C6.38416 5.43039 5.98001 5.45932 5.71966 5.71967C5.42677 6.01256 5.42677 6.48744 5.71966 6.78033L8.93875 10L5.71966 13.2197L5.63288 13.3235C5.43038 13.6158 5.45931 14.02 5.71966 14.2803C6.01256 14.5732 6.48744 14.5732 6.78034 14.2803L10 11.0613L13.2197 14.2803L13.3235 14.3671C13.6158 14.5696 14.02 14.5407 14.2803 14.2803C14.5732 13.9874 14.5732 13.5126 14.2803 13.2197L11.0612 10L14.2803 6.78033L14.3671 6.67646C14.5696 6.38416 14.5407 5.98002 14.2803 5.71967C13.9874 5.42678 13.5126 5.42678 13.2197 5.71967L10 8.93875L6.78034 5.71967L6.67646 5.63289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/white-cross.b7cfa17b7a6f06678247c0f330b1fa0e.svg";
export { ForwardRef as ReactComponent };